import React, { ReactNode, useEffect, useState } from "react";
import { Platform } from "react-native";
import { createClient, SegmentClient } from "@segment/analytics-react-native";
import { useOrgSettingsSlice } from "../../redux/slices/orgSettingsSlice";
import { SurveySegmentClientProvider } from "../../contexts/SurveySegmentClientContext";
import Constants from "expo-constants";

interface SurveySegmentClientWrapperProps {
  children: ReactNode;
}

const SurveySegmentClientWrapper = ({
  children,
}: SurveySegmentClientWrapperProps) => {
  const { initStatus } = useOrgSettingsSlice();
  const [surveySegmentClient, setSurveySegmentClient] =
    useState<SegmentClient>();

  useEffect(() => {
    if (!surveySegmentClient && initStatus?.name) {
      const isEdge =
        Platform.OS === "web" && typeof navigator !== "undefined"
          ? navigator.userAgent.includes("Edg") ||
            navigator.userAgent.includes("Edge")
          : 0;
      const client = createClient({
        writeKey: process.env.EXPO_PUBLIC_SEGMENT_KEY_SURVEY
          ? process.env.EXPO_PUBLIC_SEGMENT_KEY_SURVEY
          : Constants?.expoConfig?.extra?.segmentKey,
        trackAppLifecycleEvents: false,
        flushAt: isEdge ? 1 : 10,
        flushInterval: 10000,
        maxBatchSize: isEdge ? 1 : 10,
      });
      setSurveySegmentClient(client);
    }
  }, [initStatus?.name]);

  return surveySegmentClient ? (
    <SurveySegmentClientProvider client={surveySegmentClient}>
      {children}
    </SurveySegmentClientProvider>
  ) : (
    <>{children}</>
  );
};

export default SurveySegmentClientWrapper;
